module.exports = __webpack_public_path__ + "img/dep_iceicesandicecream.7e988207.png";